import { OperationFilter } from './operation-filter';

export function hasActiveDateRange(filters: Pick<OperationFilter, 'initialDate' | 'finalDate'>): boolean {
  return !isEmptyFilterValue(filters.initialDate) && !isEmptyFilterValue(filters.finalDate);
}

export function countActiveConfirmationFilters(filters: OperationFilter): number {
  let count = 0;

  if (!isEmptyFilterValue(filters.holderCode)) {
    count++;
  }

  if (!isEmptyFilterValue(filters.carbonCreditCode)) {
    count++;
  }

  if (!isEmptyFilterValue(filters.initialDate)) {
    count++;
  }

  if (!isEmptyFilterValue(filters.finalDate)) {
    count++;
  }

  return count;
}

export function hasPersonalizedFilters(filters: OperationFilter): boolean {
  return !isEmptyFilterValue(filters.initialDate)
    || !isEmptyFilterValue(filters.finalDate)
    || !isEmptyFilterValue(filters.operationCode)
    || !isEmptyFilterValue(filters.holderCode)
    || !isEmptyFilterValue(filters.purchaserCode)
    || !isEmptyFilterValue(filters.carbonCreditCode)
    || !isEmptyFilterValue(filters.typeCode);
}

export function isEmptyFilterValue(value: unknown): boolean {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime());
  }

  return false;
}

export function formatFilterDate(value: Date | string | null | undefined): string | undefined {
  if (isEmptyFilterValue(value)) {
    return undefined;
  }

  if (value instanceof Date) {
    return formatDateParts(value.getFullYear(), value.getMonth() + 1, value.getDate());
  }

  const normalized = String(value).trim();
  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(normalized);

  if (isoMatch) {
    return normalized;
  }

  const parsed = new Date(normalized);

  if (Number.isNaN(parsed.getTime())) {
    return undefined;
  }

  return formatDateParts(parsed.getFullYear(), parsed.getMonth() + 1, parsed.getDate());
}

export function toDatepickerValue(value?: Date | string | null): Date | null {
  const formatted = formatFilterDate(value);

  if (!formatted) {
    return null;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(formatted);

  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);

  return new Date(year, month - 1, day);
}

function formatDateParts(year: number, month: number, day: number): string {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
